
export const ROOT_COMPANY_ID = {
  HENKEL: 4798,
  HSBC: 6429,
  DIAGEO: 8648,
  COACH: 592,
  MSD: 13471,
  MSD_OLD: 13207,
  MSD_MAH: 13473,
  MSD_GSF: 13476,
  MSD_GHH: 13475,
  MSD_MMD: 13474,
  MSD_MRL: 13477,
  MERCEDES_BENZ: 13687,
  SANOFI: 13537
}

export const DEFAULT_WORK_TIME_FILTER = [
  {
    name: 'Alternate Days',
    cn_name: '做一休一',
    id: '1'
  },
  {
    name: 'Standard Work Time',
    cn_name: '做五休二',
    id: '2'
  },
  {
    name: 'One Day off per Week',
    cn_name: '做六休一',
    id: '3'
  },
  {
    name: 'Shift Work',
    cn_name: '倒班',
    id: '4'
  }
]

export const DEFAULT_ROLE_TYPE_FILTER = [
  {
    name: 'Full Time',
    cn_name: '全职',
    id: 'F'
  },
  {
    name: 'Part Time',
    cn_name: '兼职',
    id: 'P'
  },
  {
    name: 'Intern',
    cn_name: '实习',
    id: 'I'
  }
]

export const DEFAULT_SALARY_FILTER = [
  {
    name: 'Below 1K/Month',
    cn_name: '1K以下/月',
    id: '1'
  },
  {
    name: '1K-1.5K/Month',
    cn_name: '1K-1.5K/月',
    id: '2'
  },
  {
    name: '1.5K-2K/Month',
    cn_name: '1.5K-2K/月',
    id: '11'
  },
  {
    name: '2K-3K/Month',
    cn_name: '2K-3K/月',
    id: '3'
  },
  {
    name: '3K-5K/Month',
    cn_name: '3K-5K/月',
    id: '4'
  },
  {
    name: '5K-8K/Month',
    cn_name: '5K-8K/月',
    id: '5'
  },
  {
    name: '8K-12K/Month',
    cn_name: '8K-12K/月',
    id: '6'
  },
  {
    name: '12K-15K/Month',
    cn_name: '12K-15K/月',
    id: '7'
  },
  {
    name: '15K-20K/Month',
    cn_name: '15K-20K/月',
    id: '12'
  },
  {
    name: '20K-25K/Month',
    cn_name: '20K-25K/月',
    id: '8'
  },
  {
    name: '25K-50K/Month',
    cn_name: '25K-50K/月',
    id: '9'
  },
  {
    name: '50K-100K/Month',
    cn_name: '50K-100K/月',
    id: '13'
  },
  {
    name: 'Above 100K/Month',
    cn_name: '100K以上/月',
    id: '14'
  },
  {
    name: 'Not Specified',
    cn_name: '面议',
    id: '10'
  }
]

export const COMPANY_ADMIN_MENU_GROUP_KEY = {
  RECRUIT: {
    key: 'recruitManagement',
    labelKey: 'admin.company.group.recruitManagement'
  },
  COMPANY_INTERNAL: {
    key: 'companyInternalManagement',
    labelKey: 'admin.company.group.companyInternalManagement'
  },
  CUSTOMER_BRAND: {
    key: 'customerBrandManagement',
    labelKey: 'admin.company.group.customerBrandManagement'
  },
  // DATA: {
  //   key: 'dataManagement',
  //   labelKey: 'admin.company.group.dataManagement'
  // },
  REFERRAL: {
    key: 'referralManagement',
    labelKey: 'admin.company.group.referralManagement'
  }
}

export const channelDefaultCountForLinkedin = 0

// # page_num's value = "1" : current page is "公司信息-外部可见（求职者）"
// # page_num's value = "2" : current page is "团队信息-外部可见（求职者）"
// # page_num's value = "3" : current page is "职位列表页"
// # page_num's value = "4" : current page is "职位详情页"
// # page_num's value = "5" : current page is "公司信息-内部可见（员工）"
// # page_num's value = "6" : current page is "团队信息-内部可见（员工）"
// # page_num's value = "16" : current page is "职位详情页字段管理"
export const CUSTOM_LANDING_PAGE_TYPE = {
  COMPANY_INFO: '1',
  TEAM_INFO: '2',
  JOB_LIST: '3',
  JOB_DETAILS: '4',
  EMPLOYEE_COMPANY_INFO: '5',
  EMPLOYEE_TEAM_INFO: '6',
  COMPANY_INFO_PC: '10',
  TEAM_INFO_PC: '11',
  EMPLOYEE_COMPANY_INFO_PC: '12',
  EMPLOYEE_TEAM_INFO_PC: '13',
  JOB_DETAILS_PC: '14',
  COMPANY_THEME_PC: '15',
  JOB_DETAIL_FIELD_MANAGEMENT: '16'
}

// # pc
// # page_num's value = "10" : current page is "公司信息-外部可见（求职者）"
// # page_num's value = "11" : current page is "团队信息-外部可见（求职者）"
// # page_num's value = "12" : current page is "公司信息-内部可见（员工）"
// # page_num's value = "13" : current page is "团队信息-内部可见（员工）"
// # page_num's value = "14" : current page is "职位详情页"
// # page_num's value = "15" : current page is "定制公司主题页面"
export const PC_PAGE_NUM_LIST = [
  CUSTOM_LANDING_PAGE_TYPE.COMPANY_INFO_PC,
  CUSTOM_LANDING_PAGE_TYPE.TEAM_INFO_PC,
  CUSTOM_LANDING_PAGE_TYPE.EMPLOYEE_COMPANY_INFO_PC,
  CUSTOM_LANDING_PAGE_TYPE.EMPLOYEE_TEAM_INFO_PC,
  CUSTOM_LANDING_PAGE_TYPE.JOB_DETAILS_PC,
  CUSTOM_LANDING_PAGE_TYPE.COMPANY_THEME_PC
]

export const MOBILE_PAGE_NUM_MAP = {
  [CUSTOM_LANDING_PAGE_TYPE.COMPANY_INFO]: CUSTOM_LANDING_PAGE_TYPE.TEAM_INFO,
  [CUSTOM_LANDING_PAGE_TYPE.TEAM_INFO]: CUSTOM_LANDING_PAGE_TYPE.COMPANY_INFO,
  [CUSTOM_LANDING_PAGE_TYPE.EMPLOYEE_COMPANY_INFO]: CUSTOM_LANDING_PAGE_TYPE.EMPLOYEE_TEAM_INFO,
  [CUSTOM_LANDING_PAGE_TYPE.EMPLOYEE_TEAM_INFO]: CUSTOM_LANDING_PAGE_TYPE.EMPLOYEE_COMPANY_INFO
}

export const DEVICE_PAGE_NUM_MAP = {
  1: {
    pc: CUSTOM_LANDING_PAGE_TYPE.COMPANY_INFO_PC,
    mobile: '1'
  },
  [CUSTOM_LANDING_PAGE_TYPE.COMPANY_INFO_PC]: {
    pc: CUSTOM_LANDING_PAGE_TYPE.COMPANY_INFO_PC,
    mobile: '1'
  },
  2: {
    pc: CUSTOM_LANDING_PAGE_TYPE.TEAM_INFO_PC,
    mobile: '2'
  },
  [CUSTOM_LANDING_PAGE_TYPE.TEAM_INFO_PC]: {
    pc: CUSTOM_LANDING_PAGE_TYPE.TEAM_INFO_PC,
    mobile: '2'
  },
  3: {
    pc: CUSTOM_LANDING_PAGE_TYPE.JOB_LIST,
    mobile: CUSTOM_LANDING_PAGE_TYPE.JOB_LIST
  },
  4: {
    pc: CUSTOM_LANDING_PAGE_TYPE.JOB_DETAILS_PC,
    mobile: '4'
  },
  [CUSTOM_LANDING_PAGE_TYPE.JOB_DETAILS_PC]: {
    pc: CUSTOM_LANDING_PAGE_TYPE.JOB_DETAILS_PC,
    mobile: '4'
  },
  5: {
    pc: CUSTOM_LANDING_PAGE_TYPE.EMPLOYEE_COMPANY_INFO_PC,
    mobile: '5'
  },
  [CUSTOM_LANDING_PAGE_TYPE.EMPLOYEE_COMPANY_INFO_PC]: {
    pc: CUSTOM_LANDING_PAGE_TYPE.EMPLOYEE_COMPANY_INFO_PC,
    mobile: '5'
  },
  6: {
    pc: CUSTOM_LANDING_PAGE_TYPE.EMPLOYEE_TEAM_INFO_PC,
    mobile: '6'
  },
  [CUSTOM_LANDING_PAGE_TYPE.EMPLOYEE_TEAM_INFO_PC]: {
    pc: CUSTOM_LANDING_PAGE_TYPE.EMPLOYEE_TEAM_INFO_PC,
    mobile: '6'
  },
  [CUSTOM_LANDING_PAGE_TYPE.COMPANY_THEME_PC]: {
    pc: CUSTOM_LANDING_PAGE_TYPE.COMPANY_THEME_PC
  },
  [CUSTOM_LANDING_PAGE_TYPE.JOB_DETAIL_FIELD_MANAGEMENT]: {
    mobile: CUSTOM_LANDING_PAGE_TYPE.JOB_DETAIL_FIELD_MANAGEMENT
  }
}

export const VIDEO_NAVIGATION_PAGE_TYPE = {
  [CUSTOM_LANDING_PAGE_TYPE.JOB_LIST]: 'job_list',
  [CUSTOM_LANDING_PAGE_TYPE.JOB_DETAILS]: 'job_detail',
  [CUSTOM_LANDING_PAGE_TYPE.COMPANY_INFO]: 'candidate_company_homepage',
  [CUSTOM_LANDING_PAGE_TYPE.TEAM_INFO]: 'candidate_company_info_page',
  [CUSTOM_LANDING_PAGE_TYPE.EMPLOYEE_COMPANY_INFO]: 'employee_company_homepage',
  [CUSTOM_LANDING_PAGE_TYPE.EMPLOYEE_TEAM_INFO]: 'employee_company_info_page'
}

export const COMPANY_PAGE_TYPE = {
  BRANDING: 'branding',
  LANDING: 'landing',
  JOB_LIST: 'job-list',
  JOB_DETAIL: 'job-detail'
}

export const LOG_TYPE = {
  USER_MANAGEMENT: 'user_management',
  ROLE_MANAGEMENT: 'role_management'
}

export const AuditOperationName = {
  CREATE_HR: 'CREATE_HR',
  DISABLE_HR: 'DISABLE_HR',
  ENABLE_HR: 'ENABLE_HR',
  EDIT_HR: 'EDIT_HR',
  ASSIGN_ROLE: 'ASSIGN_ROLE',
  REMOVE_ROLE: 'REMOVE_ROLE',
  CREATE_ROLE: 'CREATE_ROLE',
  DELETE_ROLE: 'DELETE_ROLE',
  EDIT_ROLE: 'EDIT_ROLE'
}

export const USER_MANAGEMENT_AUDIT_OPTIONS = [
  AuditOperationName.CREATE_HR,
  AuditOperationName.DISABLE_HR,
  AuditOperationName.ENABLE_HR,
  AuditOperationName.EDIT_HR,
  AuditOperationName.ASSIGN_ROLE,
  AuditOperationName.REMOVE_ROLE
]

export const ROLE_MANAGEMENT_AUDIT_OPTIONS = [
  AuditOperationName.CREATE_ROLE,
  AuditOperationName.DELETE_ROLE,
  AuditOperationName.EDIT_ROLE
]

export const COMPANY_STATUS = {
  ALL: '0',
  PENDING: '1',
  NEW: '2',
  REJECTED: '3',
  APPROVED: '4',
  CLOSED: '5'
}

export const COMPANY_STATUS_MAP = {
  [COMPANY_STATUS.PENDING]: 'pending',
  [COMPANY_STATUS.NEW]: 'new',
  [COMPANY_STATUS.REJECTED]: 'rejected',
  [COMPANY_STATUS.APPROVED]: 'approved',
  [COMPANY_STATUS.CLOSED]: 'closed'
}

export const POST_STATUS = {
  FINISHED: '2',
  PENDING: '1',
  NEW: '0'
}

export const OPERATION_TYPE = {
  ADD: 'ADD',
  DELETE: 'DELETE',
  UPDATE: 'UPDATE'
}

export const JOB_POSTING_STATUS = {
  PENDING: 'PENDING',
  FINISHED: 'FINISHED',
  NEW: 'NEW'
}

export const RESUME_SDK_TAG_TYPES = {
  SKILLS: 'skills',
  EDUCATION: 'education',
  RISKS: 'risks',
  STABILITY: 'stability',
  WORK_EXPERIENCE: 'work_experience'
}

export const RESUME_SDK_TAG_KEYS = {
  COMPANY_LEVEL: 'company_level',
  POSITION: 'position',
  INDUSTRY: 'industry',
  JOB_SKILL: 'job_skill',
  SOFT_SKILL: 'soft_skill',
  COLLEGE_LEVEL: 'college_level',
  ABROAD_EDU: 'abroad_edu'
}

export const CRM_TAG_TYPES = {
  SCREENED: 'Screened under',
  INTERVIEWED: 'Interviewed under',
  OPENED: 'Opened',
  SHARED: 'Shared',
  APPLIED: 'Applied for',
  HIRED: 'Hired under',
  OTHER: 'Others'
}

export const FILTER_GROUP_TYPE = {
  // APPLICATION_DETAIL: 0,
  // PROFILE_DETAIL: 1,
  ASSESSMENT_FIT: 'assessmentFit',
  PROBLEM_SOLVING_FIT: 'problemSolvingFit',
  CANDIDATE_TYPE: 'candidateType',
  SOURCE: 'source',
  EMPLOYER: 'employer',
  JOB_TITLE: 'jobTitle',
  INDUSTRY: 'industry',
  SKILL: 'skill',
  EDUCATION: 'education',
  CRM_TAG: 'crmTag',
  CRM_CAMPAIGN: 'crmCampaign',
  PROFILE_DETAIL: 'profileDetail',
  APPLICATION_DETAIL: 'applicationDetail',
  CANDIDATE_BEHAVIOR: 'candidateBehavior',
  CANDIDATE_PREFERENCE: 'candidatePreference',
  OTHER_FACTOR: 'otherFactor'
}

export const COMPANY_LEVEL_ORDER_LIST = [
  '中国互联网企业100强',
  '中国民营企业500强',
  '《财富》世界500强',
  '全球品牌价值500强'
]

export const OFFER_LETTER_PAGE_TYPE = {
  FIELD: 'field',
  TEMPLATE: 'template',
  INVITE_RECORD: 'invite'
}

export const OFFER_LETTER_INVITE_STATUS = {
  // 已邀请
  INVITED: 0,
  // 已接受
  ACCEPTED: 1,
  // 已拒绝
  REJECTED: 2
}

export const OFFER_LETTER_EVENT_STATUS = {
  // 已邀请
  INVITED: 0,
  // 已接受
  ACCEPTED: 1,
  // 已拒绝
  REJECTED: 2,
  // 已重新邀请
  RE_INVITED: 3,
  // 已提醒
  REMINDED: 4
}

export const OFFER_LETTER_TEMPLATE_FIELD_TYPE = {
  SELECT: 'SELECT',
  SINGLE: 'SINGLE',
  TEXT: 'TEXT',
  TEXTAREA: 'TEXTAREA',
  DATE: 'DATE',
  SIGN: 'SIGN'
}

export const CUSTOM_SETTING_CONTENT_TYPE = {
  TEXT: 'text',
  SELECT: 'select',
  IMAGE: 'image',
  FONT: 'font',
  COLOR: 'color',
  TINYMCE: 'tinymce',
  TEXTAREA: 'textarea',
  SWITCH: 'switch',
  POSITION: 'position',
  LIST: 'list'
}

export const COMPANY_BALANCE_ACTIVITY = {
  PURCHASED: '1',
  ALLOCATED: '2',
  POST_PAY: '3',
  REFUND: '4',
  REDISTRIBUTION: '5'
}

export const COMPANY_REWARD_TYPE = {
  POINTS: 'points',
  CASH: 'cash',
  PAYROLL: 'payroll'
}

export const AI_SEARCH_PARAMS_MAPPING = {
  job_function: 'job_function_name',
  industry: 'industry_name',
  major: 'major_name',
  job_title: 'job_title',
  seniority: 'seniority_name',
  hard_skill: 'hard_skill_name',
  soft_skill: 'soft_skill_name',
  recent_industry: 'recent_industry_name',
  activeness_type: 'activeness',
  location: 'location',
  degree: 'maxDegree',
  work_year: 'workYear',
  company_name: 'company_name'
}

export const AI_EXTRA_PARAMS = [
  'job_function_name',
  'industry_name',
  'major_name',
  'job_title',
  'seniority_name',
  'hard_skill_name',
  'soft_skill_name',
  'recent_industry_name',
  'company_name'
]

export const SENIORITY = {
  INTERN: 'Intern',
  ENTRY_LEVEL: 'Entry Level',
  JUNIOR: 'Junior',
  MIDDLE_LEVEL: 'Mid-Level',
  SENIOR: 'Senior',
  LEADER: 'Lead',
  PRINCIPAL: 'Principal',
  MANAGER: 'Manager',
  DIRECTOR: 'Director',
  SENIOR_DIRECTOR: 'Senior Director',
  VP: 'Vice President (VP)',
  EVP: 'Executive Vice President (EVP)',
  CHIEF_OFFICER: 'Chief Officer (e.g., CTO, CFO)'
}

/* eslint-disable quote-props */
export const SENIORITY_CN_NAME_MAP = {
  '实习': SENIORITY.INTERN,
  '入门': SENIORITY.ENTRY_LEVEL,
  '初级': SENIORITY.JUNIOR,
  '中级': SENIORITY.MIDDLE_LEVEL,
  '高级': SENIORITY.SENIOR,
  '主管': SENIORITY.LEADER,
  '负责人': SENIORITY.PRINCIPAL,
  '经理': SENIORITY.MANAGER,
  '总监': SENIORITY.DIRECTOR,
  '高级总监': SENIORITY.SENIOR_DIRECTOR,
  '副总裁': SENIORITY.VP,
  '执行副总裁': SENIORITY.EVP,
  '首席官': SENIORITY.CHIEF_OFFICER
}
